import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  companyProfileService,
  type CompanyProfileUpdateRequest,
  type CompanyProfileLabellingUpdateRequest,
} from '../../services/api/companyProfileService';

export const fetchCompanyProfile = createAsyncThunk(
  'companyProfile/fetch',
  async (
    { tenantId, supplierPartyId }: { tenantId: number; supplierPartyId: number },
    { rejectWithValue },
  ) => {
    try {
      return await companyProfileService.getCompanyProfile(tenantId, supplierPartyId);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to load company profile');
    }
  },
);

export const saveCompanyProfile = createAsyncThunk(
  'companyProfile/save',
  async (request: CompanyProfileUpdateRequest, { rejectWithValue }) => {
    try {
      const result = await companyProfileService.updateCompanyProfile(request);
      // Echo the submitted values back so the slice can refresh the cached
      // profile without a second round-trip (mirrors the request body shape).
      return { request, result };
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to save company profile');
    }
  },
);

export const saveCompanyProfileLabelling = createAsyncThunk(
  'companyProfile/saveLabelling',
  async (request: CompanyProfileLabellingUpdateRequest, { rejectWithValue }) => {
    try {
      const result = await companyProfileService.updateCompanyProfileLabelling(request);
      // Echo the submitted values back so the slice can refresh the cached
      // labelling block without a second round-trip.
      return { request, result };
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to save labelling information');
    }
  },
);
